<script>
import MessagePreview from 'dashboard/components/widgets/conversation/MessagePreview.vue';
import { MESSAGE_TYPE } from 'shared/constants/messages';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { emitter } from 'shared/helpers/mitt';

export default {
  name: 'ReplyTo',
  components: {
    MessagePreview,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    messageType: {
      type: Number,
      required: true,
    },
    parentHasAttachments: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { MESSAGE_TYPE };
  },
  methods: {
    scrollToMessage() {
      emitter.emit(BUS_EVENTS.SCROLL_TO_MESSAGE, {
        messageId: this.message.id,
        options: {
          noMessageNote: "Note: The referenced message is too old and requires loading additional history to view details.",
        },
      });
    },
  },
};
</script>

<template>
  <div
    class="reply-to-align-wrapper"
    :class="{
      'align-start': messageType === MESSAGE_TYPE.INCOMING,
      'align-end': messageType === MESSAGE_TYPE.OUTGOING,
    }"
    @click="scrollToMessage"
  >
    <div class="reply-to-custom-style">
      <MessagePreview
        class="cursor-pointer"
        :message="message"
        :show-message-type="false"
        :show-sender-name="true"
        :default-empty-message="$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')"
        :show-picture-and-video-content="true"
      />
    </div>
  </div>
</template>

<style scoped>
.reply-to-align-wrapper {
  display: flex;
  max-width: min(496px, 84%);
  width: 100%;
  box-sizing: border-box;
}
.align-start {
  align-self: flex-start;
  justify-content: flex-start;
}
.align-end {
  align-self: flex-end;
  justify-content: flex-end;
}
.reply-to-custom-style {
  background: #EDEDED;
  color: #808080;
  font-size: 12px;
  padding: 10px 10px 10px 12px;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  margin-top: 0.1rem;
  max-width: 100%;
  box-sizing: border-box;
}
.reply-to-align-wrapper.align-start {
  margin-left: 1rem;
}
.reply-to-align-wrapper.align-end {
  margin-right: calc(1.5rem + 16px);
}
.reply-to-custom-style .message-preview-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: normal;
  line-height: 1.5;
  max-height: 3em;
}
</style>
